import React from "react";
import { useArgoContext } from "@amzn/awsscm-argo-core";
import { useLazyQuery } from "@apollo/react-hooks";
import { useEffect, useState } from "react";
import { Icon, Link, SpaceBetween, Spinner } from "@amzn/awsui-components-react-v3";
import {getS3DownloadPreSignedUrl} from "../../../../gql/queries/getS3PresignedDownloadUrl";

export const GetPreSignedUrlBlockFileName = (props)=>{
    const [fileDownload, setFileDownload] = useState(false);
    const [startTime, setStartTime] = useState(new Date().valueOf());
    const context = useArgoContext();
    const childPublisher = context.initialMetricsPublisher.newChildActionPublisherForMethod('RequestInventoryPage');

    const onCompleteHandle = (response, startTime, childPublisher) =>{
        if(response && response.getS3DownloadPreSignedUrl && response.getS3DownloadPreSignedUrl.s3PresignedUrl) {
            window.open(response.getS3DownloadPreSignedUrl.s3PresignedUrl);
        }
        const endTime = new Date().valueOf();
        childPublisher.publishTimerMonitor("GetS3DownloadPreSignedUrlApiResponseTime", endTime-startTime);
    }
    const onErrorHandle = (error, context, childPublisher) => {
        context.logger.error("GetS3DownloadPreSignedUrl api failure with error ", error);
        childPublisher.publishCounterMonitor("GetS3DownloadPreSignedUrl", 1);
    }

    const [getS3PreSignedUrl, {loading}] = useLazyQuery(getS3DownloadPreSignedUrl, {
        onCompleted: (response) => onCompleteHandle(response, startTime, childPublisher),
        onError: (error) => onErrorHandle(error, context, childPublisher),
        fetchPolicy: 'no-cache'
    });
    useEffect(()=>{
        if(fileDownload){
            setStartTime((new Date()).valueOf());
            getS3PreSignedUrl({variables:{"s3Key": props.s3Key}});
            setFileDownload(false);
        }
    }, [fileDownload]);
    return (
        <div onClick={()=> setFileDownload(true)}>
            { loading?<Spinner/>:
                <SpaceBetween size="xxs" direction="horizontal">
                    <Link><Icon name='download' variant="link" /> {props.fileName}</Link>
                </SpaceBetween>
            }
        </div>
    )
}